import React from "react";
import RSCollapse, { Panel as RSPanel } from "rc-collapse";
import { FaChevronDown } from "react-icons/fa";
import styled from "styled-components";
import { STYLES } from "../../constants";

function Collapse({ children, ...restProps }) {
  return (
    <RSCollapse {...restProps} expandIcon={expandIcon}>
      {children}
    </RSCollapse>
  );
}

function Panel({ ...props }) {
  return <RSPanel {...props} />;
}

function expandIcon({ isActive }) {
  return (
    <FaChevronDown
      className="rc-chevron"
      style={{
        transform: `rotate(${isActive ? -180 : 0}deg)`
      }}
    />
  );
}

const SCollapse = styled(Collapse)`
  &.rc-collapse {
    border: none;
    background-color: transparent;
    > .rc-collapse-item {
      border: none;
      outline: none;

      > .rc-collapse-header {
        outline: none;
        color: ${STYLES.color.black};
        flex-direction: row-reverse;
        justify-content: flex-end;
        padding-left: 0;
        padding-right: 5px;

        .rc-chevron {
          margin-left: auto;
          vertical-align: -0.125em;
          transition: transform 0.2s;
          font-size: 14px;
        }
      }

      .rc-collapse-content {
        overflow: unset;
        padding: 10px 0 0px 0px;
      }
    }
  }
`;

export { Panel };
export default SCollapse;
